import authAxios from "../../utility/authAxios";
import { API_VERSION, SAAS_SERVICE_PATH } from "../../config/axios";
import { setHttpParams } from "../../utility/utils";

const API_URI = `${API_VERSION}/${SAAS_SERVICE_PATH}/counter-panel`;

export const searchTrips = async (params = {}) => {
    params = setHttpParams(params);
    return authAxios.get(`${API_URI}/search?${params}`);
};

export const tripDetails = async (fareId, tripId, params) => {
    params = setHttpParams(params);
    return authAxios.get(
        `${API_URI}/trip-details/${fareId}/${tripId}?${params}`
    );
};

export const updateDepartureArrival = async (tripId, data, params) => {
    params = setHttpParams(params);
    return authAxios.patch(
        `${API_URI}/trip-counters/${tripId}?${params}`,
        data
    );
};

export const getStaions = async () => {
    return authAxios.get(`${API_URI}/station-list`);
};

export const confrimSeatSelection = async (data, params) => {
    params = params ? `?${params}` : "";
    return authAxios.post(`${API_URI}/trip/select-seat${params}`, data);
};

export const sessionDestroy = async (session_id) => {
    return authAxios.post(`${API_URI}/deselect-by-session`, {
        session_id,
    });
};

export const deselectSeat = async (data, params) => {
    params = params ? `?${params}` : "";
    return authAxios.post(`${API_URI}/trip/deselect-seat${params}`, data);
};

export const bookTickets = async (data, params) => {
    params = params ? `?${params}` : "";
    return authAxios.post(`${API_URI}/trip/book-ticket${params}`, data);
};

export const confirmTickets = async (data) => {
    return authAxios.post(`${API_URI}/trip/confirm-ticket`, data);
};

export const cancelTickets = async (data, params) => {
    params = params ? `?${params}` : "";
    return authAxios.post(`${API_URI}/trip/issue-or-cancel${params}`, data);
};

export const cancelTicketsByOTP = async (data, params) => {
    params = params ? `?${params}` : "";
    return authAxios.post(
        `${API_URI}/booking-cancel/otp/verify${params}`,
        data
    );
};

export const getTicketData = async (pnr, params) => {
    params = params ? `?${params}` : "";
    return authAxios.get(`${API_URI}/trip/${pnr}/tickets${params}`);
};

export const getTripSheet = async (tripId, params) => {
    params = params ? `?${params}` : "";
    return authAxios.get(`${API_URI}/trips/${tripId}/trip-sheet${params}`);
};

export const getTripExpenses = async (tripId) => {
    return authAxios.get(`${API_URI}/trip-expenses?trip_id=${tripId}`);
};

export const createTripExpense = async (data) => {
    return authAxios.post(`${API_URI}/trip-expenses`, data);
};

export const getBookedSeats = async (seatId, params) => {
    params = setHttpParams(params);
    return authAxios.get(`${API_URI}/seats/${seatId}/bookings?${params}`);
};

export const getBoookingStatus = async (tripId) => {
    return authAxios.get(`${API_URI}/trips/${tripId}/status`);
};

export const getSeatStatus = async (tripId, fareId) => {
    return authAxios.get(
        `${API_URI}/trips/${tripId}/seat-status?fare_id=${fareId}`
    );
};

export const saveParticular = async (tripId, counterId, data) => {
    return authAxios.post(
        `${API_URI}/trips/${tripId}/particulars/${counterId}`,
        data
    );
};

export const findLatestGoodsPolicy = async (companyId) => {
    return authAxios.get(`${API_URI}/goods/latest/${companyId}`);
};

export const validateTicket = async (ticketNo) => {
    return authAxios.get(
        `${API_URI}/tickets/validate?ticket_number=${ticketNo}`
    );
};

export const getGoodsInformationByTicketNumber = async (ticketNumber) => {
    return authAxios.get(`${API_URI}/goods/${ticketNumber}`);
};

export const createGoods = async (data) => {
    return authAxios.post(`${API_URI}/goods`, data);
};

export const priceSummary = async (data, params) => {
    params = params ? `?${params}` : "";
    return authAxios.post(`${API_URI}/trip/price-summary${params}`, data);
};

export const getSeatDetails = async (seatId, status = "seats") => {
    return authAxios.get(`${API_URI}/${status}/${seatId}/details`);
};

export const getPassengerInfoByMobileNumber = async (mobileNumber) => {
    return authAxios.get(`${API_URI}/passengers/${mobileNumber}`);
};
